import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import "./NewOrderModal.css"
import { useState } from 'react';
import Swal from "sweetalert2";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus  } from "@fortawesome/free-solid-svg-icons";
import NewCustomerModal from '../NewUserModal/NewCustomerModal';

//LOG FUNCTION
import { storeOrderLog } from "../../Helper_Library.js";

const NewOrderModal = ({ show, requestClose }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    //INPUTS CONTROLS
    const [customer, setCustomer] = useState(null);
    const [model, setModel] = useState(null);
    const [serialNumber, setSerialNumber] = useState(null);
    const [failure, setFailure] = useState(null);
    const [personContact, setPersonContact] = useState(null);
    const [personContactData, setPersonContactData] = useState(null);
    const [address, setAddress] = useState(null);
    const [customersCombo, setCustomersCombo] = useState([]);
    const [notes, setNotes] = useState(null);


    //ADD NEW USER MODAL CONTROLLER
    const [showModal_AddUser, setShowModal_AddUser] = useState(false);   
    const requestCloseModal_AddUser = () => { setShowModal_AddUser(false); getUsersListing(); }
    const openModal_AddUser = () => { setShowModal_AddUser(true); }
    
    //
    const options = customersCombo
        .filter(item => item.groupname === "Clientes")
        .map(item => ({
            value: item.customer_name,
            label: item.customer_name
    }));


    const getUsersListing = async () =>{

        const endpoint = "getUsersListing";
        
        const response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
        });

        const responseContent = await response.json();

        setCustomersCombo(responseContent);


    } //END FUNCTION

    function getCurrentDateTimeInArgentina() {

        const now = new Date();
        const argentinaTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Argentina/Buenos_Aires' }));

        const year = argentinaTime.getFullYear();
        const month = String(argentinaTime.getMonth() + 1).padStart(2, '0');
        const day = String(argentinaTime.getDate()).padStart(2, '0');
        const hours = String(argentinaTime.getHours()).padStart(2, '0');
        const minutes = String(argentinaTime.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}`;

    }//

    const addNewOrder = async () => {

        //MAIN VALIDATION
        if(!customer || !model || !serialNumber || !failure || !personContact || !address) {

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Faltan datos obligatorios por completar.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }//


        //DATOS MINIMOS
        if(serialNumber.length < 4) { 

            //Show message sweet alert
            Swal.fire({
                title: "Datos Mínimos",
                text: "El campo Nro de Serie debe tener mínimo 4 caracteres.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;

        }


        //
        const metadata = {
            "customer":customer,
            "model":model.replace(/[\t\\']/g, ''),
            "serialNumber":serialNumber.replace(/[\t\\']/g, ''),
            "failure":failure.replace(/[\t\\']/g, ''),
            "personContact":personContact.replace(/[\t\\']/g, ''),
            "issuesDate": getCurrentDateTimeInArgentina(),
            "status": "Por asignar técnico",
            "tecnico": "---",
            "address": address ? address.replace(/[\t\\']/g, '') : "",
            "personContactData": personContactData ? personContactData.replace(/[\t\\']/g, '') : "",
            "notes": notes ? notes.replace(/[\t\\']/g, '') : ""
        };

        //
        const requestBody ="{\"metadata\":\"" + JSON.stringify(metadata).replace(/"/g, '\\"') + "\"}";
        
        const endpoint = "addOrder";

        const response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
            body: requestBody
        });

        const responseContent = await response.json();

        //STORE LOG INFORMATION
        storeOrderLog(responseContent.order_id, sessionUser.customer_name, "Creación del Servicio", "En espera de asignación de técnico.");

        //Show message sweet alert
        Swal.fire({
            title: "¡Éxito!",
            text: "Operación realizada exitosamente.",
            icon: "success",
            confirmButtonText: "OK"
        });


        //CLOSE MODAL
        requestClose(false);

    } //

    const onModalShow = () => {

        //GET USER SESSION
        if(sessionUser.groupname === "Clientes") { 
            
            
            setCustomer(sessionUser.customer_name); 

            //CLEAR FIELDS
            setModel("");
            setSerialNumber("");
            setFailure("");
            setPersonContact("");
            setAddress("");
            setNotes("");
        
        
        }
        else { 
            
            getUsersListing(); 

              //CLEAR FIELDS
            setCustomer("");
            setModel("");
            setSerialNumber("");
            setFailure("");
            setPersonContact("");
            setAddress("");
            setNotes("");
        
        
        }


      


    } //END FUNCTION

    

    return (
        <>
        <Modal show={show} onShow={onModalShow} onHide={requestClose} className={'mainOrderModal'}>
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Agregar Orden de Servicio</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row>
                    <Col xs={12}>
                        <Form.Group>
                            <Form.Label className={'newOrderlabels'}>Cliente</Form.Label>
                            { sessionUser.groupname === "Clientes" ? (
                                 <Form.Control 
                                    type="text" 
                                    value={sessionUser.customer_name} 
                                    disabled="disabled"
                                    
                                    />
                                 ) : (
                                    <>  
                                    <Row>
                                        <Col xs={11}>
                                            <Select 
                                                style={{fontSize:"14px"}}
                                                options={options}
                                                onChange={(selectedOption) => setCustomer(selectedOption.value)}
                                                >
                                            </Select>
                                        </Col>
                                        <Col xs={1} style={{textAlign:"center", paddingTop: "5px", cursor:"pointer"}}>
                                            <FontAwesomeIcon 
                                            icon={faCirclePlus} 
                                            style={{fontSize: "20px"}} 
                                            onClick = {openModal_AddUser}
                                            />
                                        </Col>
                                    </Row>
                                    </>
                                )
                            }
                            <br />
                        </Form.Group>
                    </Col>
                    <Col xs={6}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Modelo</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Modelo del equipo..."
                             maxLength={80} 
                             onChange={(event)=> setModel(event.target.value)} /><br />
                        </Form.Group>
                    </Col>
                    <Col xs={6}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>N° de Serie</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Número de Serie" 
                             maxLength={80} 
                             onChange={(event)=> setSerialNumber(event.target.value)} /><br />
                        </Form.Group>
                    </Col>

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Falla / Detalles</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Falla del equipo" 
                             maxLength={200} 
                             onChange={(event)=> setFailure(event.target.value)} /><br />
                        </Form.Group>
                    </Col>

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Persona Contacto</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Nombre y apellido del solicitante..." 
                             maxLength={80} 
                             onChange={(event)=> setPersonContact(event.target.value)} /><br />
                        </Form.Group>
                    </Col>

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Datos del Contacto</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Teléfono / Email" 
                             maxLength={80} 
                             onChange={(event)=> setPersonContactData(event.target.value)} /><br />
                        </Form.Group>
                    </Col>

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Dirección del Servicio</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Direccion..." 
                             maxLength={200} 
                             onChange={(event)=> setAddress(event.target.value)} /><br />
                        </Form.Group>
                    </Col>
                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Notas / Observaciones</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Notas varias" 
                             maxLength={200} 
                             onChange={(event)=> setNotes(event.target.value)} /><br />
                        </Form.Group>
                    </Col>
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            <Button 
                variant="success" 
                size='sm'
                onClick={addNewOrder}
                >

                Guardar Datos
            </Button>
            </Modal.Footer>
        </Modal>

        {/* MODAL ADD USER COMPONENT */}
        <NewCustomerModal show={showModal_AddUser} requestClose={requestCloseModal_AddUser}/>

        </>
    );
}

export default NewOrderModal;